import { ModalName } from 'features/Modals';
import { modalStore } from 'state/store';
import { StreamManager } from './streamManager';

class MediaSharing {
    public resolvePromiseFunction: ((value: MediaStream) => void) | null = null;
    public rejectPromiseFunction: ((reason?: string) => void) | null = null;
    public streamManager: StreamManager | null = null;

    private isOverridden = false;
    private getDisplayMediaPromise: Promise<MediaStream> | null = null;
    private originGetDisplayMedia: ((options?: DisplayMediaStreamOptions) => Promise<MediaStream>) | null = null;

    public init(): void {
        if (this.isOverridden) {
            return;
        }

        if (!navigator.mediaDevices?.getDisplayMedia) return;

        this.originGetDisplayMedia = navigator.mediaDevices.getDisplayMedia.bind(navigator.mediaDevices);

        navigator.mediaDevices.getDisplayMedia = async (
            streamOptions?: DisplayMediaStreamOptions,
        ): Promise<MediaStream> => {
            this.getDisplayMediaPromise = new Promise<MediaStream>((res, rej) => {
                this.resolvePromiseFunction = res;
                this.rejectPromiseFunction = rej;
            });

            this.streamManager = new StreamManager(streamOptions, this.originGetDisplayMedia!);

            modalStore.toggleModal(ModalName.SCREEN_SHARE);

            return this.getDisplayMediaPromise;
        };

        this.isOverridden = true;
    }

    public resolveGetDisplayMediaPromise(stream: MediaStream): void {
        this.resolvePromiseFunction?.(stream);
        this.cleanupGetDisplayMediaPromise();
    }

    public rejectGetDisplayMediaPromise(reason?: string): void {
        this.rejectPromiseFunction?.(reason);
        this.cleanupGetDisplayMediaPromise();
    }

    private cleanupGetDisplayMediaPromise(): void {
        this.getDisplayMediaPromise = null;
        this.resolvePromiseFunction = null;
        this.rejectPromiseFunction = null;
        this.streamManager = null;
    }
}

export const mediaSharing = new MediaSharing();
